<template>
  <!--START PRICING-->
  <section class="section pt-5 scroll-select" id="pricing">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">Nossos Planos</h1>
          <div class="section-title-border margin-t-20"></div>
          <p
            class="section-subtitle font-secondary text-muted text-center padding-t-30"
          >
            Conheça nossos planos para que suas ideias inovadoras finalmente
            ganhem o mundo.
          </p>
        </div>
      </div>
      <div class="row margin-t-50">
        <div class="col-lg-4">
          <div class="text-center pricing-box hover-effect">
            <h4 class="text-uppercase">Economico</h4>
            <h1>R$99,90</h1>
            <h6 class="text-uppercase text-muted">Cobrança mensal</h6>
            <div class="pricing-border"></div>
            <div class="plan-features margin-t-30">
              <p>Consultoria: <b class="text-custom">1 por mês</b></p>
              <p>Soluções: <b class="text-custom">básico</b></p>
              <p>Suporte: <b class="text-custom">básico</b></p>
              <p>
                <b class="text-custom">1</b> cotação junto a investidores por
                mês
              </p>
              <p><b class="text-custom">Sem</b> taxas adicionais</p>
            </div>
            <a
              href="#"
              class="btn btn-custom waves-effect waves-light margin-t-30"
              >Voe</a
            >
          </div>
        </div>
        <div class="col-lg-4">
          <div
            class="text-center pricing-box bg-white hover-effect price-active"
          >
            <h4 class="text-uppercase">Foguete</h4>
            <h1>R$290,90</h1>
            <h6 class="text-uppercase text-muted">Cobrança mensal</h6>
            <div class="pricing-border"></div>
            <div class="plan-features margin-t-30">
              <p>Consultoria: <b class="text-custom">5 por mês</b></p>
              <p>Soluções: <b class="text-custom">200 ferramentas</b></p>
              <p>Suporte: <b class="text-custom">ilimitado</b></p>
              <p>
                <b class="text-custom">10</b> Cotações junto a investidores por
                mês
              </p>
              <p><b class="text-custom">Sem</b> taxas adicionais</p>
            </div>
            <a
              href="#"
              class="btn btn-custom waves-effect waves-light margin-t-30"
              >Decole</a
            >
          </div>
        </div>
        <div class="col-lg-4">
          <div class="text-center pricing-box hover-effect">
            <h4 class="text-uppercase">Millenium Falcon</h4>
            <h1>R$590,90</h1>
            <h6 class="text-uppercase text-muted">Cobrança mensal</h6>
            <div class="pricing-border"></div>
            <div class="plan-features margin-t-30">
              <p>Consultoria: <b class="text-custom">ilimitada</b></p>
              <p>Soluções: <b class="text-custom">ilimitadas</b></p>
              <p>Suporte: <b class="text-custom">ilimitado</b></p>
              <p><b class="text-custom">Cotações</b> ilimitadas</p>
              <p><b class="text-custom">Sem</b> taxas adicionais</p>
            </div>
            <a
              href="#"
              class="btn btn-custom waves-effect waves-light margin-t-30"
              >Ao infinito e além!</a
            >
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--ENd PRICING-->
</template>

<script>
"use strict";
export default {
  name: "Pricing",
  props: {}
};
</script>
